import(/* webpackMode: "eager" */ "/var/www/vhosts/castly.nl/httpdocs/node_modules/next/dist/client/link.js");
